import * as React from "react";
import styled, { css } from "styled-components";
import Icon from "components/common/Icon";
const Container = styled.div(
  ({ theme }) => css`
    cursor: col-resize;
    color: ${theme.colors.gray[70]};
    margin-left: ${theme.spacings.xxs};
    user-select: none;
  }
    
  `
);
const ResizeHandle = ({ onMouseDown = void 0, onTouchStart = void 0, colTitle }) => {
  const _onMouseDown = (e) => {
    e == null ? void 0 : e.preventDefault();
    onMouseDown == null ? void 0 : onMouseDown(e);
  };
  const _onTouchStart = (e) => {
    e == null ? void 0 : e.preventDefault();
    onTouchStart == null ? void 0 : onTouchStart(e);
  };
  return /* @__PURE__ */ React.createElement(
    Container,
    {
      onMouseDown: _onMouseDown,
      onTouchStart: _onTouchStart,
      role: "separator",
      "aria-label": `Resize ${colTitle} column`,
      title: `Resize ${colTitle} column`
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "arrows_outward" })
  );
};
export default ResizeHandle;
